import { STATUS_CHECK_LABEL } from '@lib/utils/statuses';
import { bgLastUpdatedToUk } from '@lib/utils/stringHelper';
import { StyledGapContainer } from '@views/auth/signup/styles';

import {
  StyledButton,
  StyledDate,
  StyledHeader,
  StyledParagraph,
  StyledSnippet,
  StyledStatusUk,
  StyledUkBox,
} from '../../statusBoxStyles';

type InvitedBoxSubmittedUkProps = {
  isMobileDevice: boolean;
  handleNoLongerAvailable: () => void;
  EditableSnippet?: string;
  bg_last_updated: string | null;
  is_archived: boolean | null;
};
export const InvitedBoxSubmittedUk = ({
  isMobileDevice,
  bg_last_updated,
  handleNoLongerAvailable,
  EditableSnippet,
  is_archived,
}: InvitedBoxSubmittedUkProps) => {
  const formattedDate = bgLastUpdatedToUk(bg_last_updated);
  return (
    <StyledUkBox isMobileDevice={isMobileDevice}>
      <div className='content'>
        <StyledGapContainer gap={16}>
          <StyledHeader>
            <StyledStatusUk>Status: Available</StyledStatusUk>
            <StyledDate>{formattedDate}</StyledDate>
          </StyledHeader>
          <StyledGapContainer gap={12}>
            <StyledParagraph className='red-text'>
              This is not currently a booking.
            </StyledParagraph>
            <StyledParagraph>
              If Casting intends to potentially book you, you will receive a
              notification asking to re-confirm your availability with &quot;
              {STATUS_CHECK_LABEL}&quot;. If you were not selected, it is
              unlikely that you will receive an update from casting, so please
              do not hesitate to submit for other work.
            </StyledParagraph>
          </StyledGapContainer>

          <StyledButton
            disabled={is_archived}
            onClick={handleNoLongerAvailable}
            width={255}
          >
            Change my status to unavailable
          </StyledButton>
          {!!EditableSnippet && (
            <StyledSnippet
              dangerouslySetInnerHTML={{ __html: EditableSnippet }}
            />
          )}
        </StyledGapContainer>
      </div>
    </StyledUkBox>
  );
};
